"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MeetingInfoV2PasswordError = exports.MeetingInfoV2CaptchaError = exports.MeetingInfoV2AdhocMeetingError = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/wrapNativeSuper"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _constants = require("../constants");
var _metrics = _interopRequireDefault(require("../metrics"));
var _constants2 = _interopRequireDefault(require("../metrics/constants"));
var _utilv = _interopRequireDefault(require("./utilv2"));
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PASSWORD_ERROR_DEFAULT_MESSAGE = 'Password required. Call fetchMeetingInfo() with password argument';
var CAPTCHA_ERROR_DEFAULT_MESSAGE = 'Captcha required. Call fetchMeetingInfo() with captchaInfo argument';
var ADHOC_MEETING_DEFAULT_ERROR = 'Failed starting the adhoc meeting, Please contact support team ';
var CAPTCHA_ERROR_REQUIRES_PASSWORD_CODES = [423005, 423006];

/**
 * Error to indicate that wbxappapi requires a password
 */
var MeetingInfoV2PasswordError = /*#__PURE__*/function (_Error) {
  (0, _inherits2.default)(MeetingInfoV2PasswordError, _Error);
  var _super = _createSuper(MeetingInfoV2PasswordError);
  /**
   *
   * @constructor
   * @param {Number} [wbxAppApiErrorCode]
   * @param {Object} [meetingInfo]
   * @param {String} [message]
   */
  function MeetingInfoV2PasswordError(wbxAppApiErrorCode, meetingInfo) {
    var _this;
    var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PASSWORD_ERROR_DEFAULT_MESSAGE;
    (0, _classCallCheck2.default)(this, MeetingInfoV2PasswordError);
    _this = _super.call(this, "".concat(message, ", code=").concat(wbxAppApiErrorCode));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "meetingInfo", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "sdkMessage", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wbxAppApiCode", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "body", void 0);
    _this.name = 'MeetingInfoV2PasswordError';
    _this.sdkMessage = message;
    _this.stack = new Error().stack;
    _this.wbxAppApiCode = wbxAppApiErrorCode;
    _this.meetingInfo = meetingInfo;
    return _this;
  }
  return (0, _createClass2.default)(MeetingInfoV2PasswordError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
/**
 * Error generating a adhoc space meeting
 */
exports.MeetingInfoV2PasswordError = MeetingInfoV2PasswordError;
var MeetingInfoV2AdhocMeetingError = /*#__PURE__*/function (_Error2) {
  (0, _inherits2.default)(MeetingInfoV2AdhocMeetingError, _Error2);
  var _super2 = _createSuper(MeetingInfoV2AdhocMeetingError);
  /**
   *
   * @constructor
   * @param {Number} [wbxAppApiErrorCode]
   * @param {String} [message]
   */
  function MeetingInfoV2AdhocMeetingError(wbxAppApiErrorCode) {
    var _this2;
    var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ADHOC_MEETING_DEFAULT_ERROR;
    (0, _classCallCheck2.default)(this, MeetingInfoV2AdhocMeetingError);
    _this2 = _super2.call(this, "".concat(message, ", code=").concat(wbxAppApiErrorCode));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "sdkMessage", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "wbxAppApiCode", void 0);
    _this2.name = 'MeetingInfoV2AdhocMeetingError';
    _this2.sdkMessage = message;
    _this2.stack = new Error().stack;
    _this2.wbxAppApiCode = wbxAppApiErrorCode;
    return _this2;
  }
  return (0, _createClass2.default)(MeetingInfoV2AdhocMeetingError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
/**
 * Error to indicate that preferred webex site not present to start adhoc meeting
 */
exports.MeetingInfoV2AdhocMeetingError = MeetingInfoV2AdhocMeetingError;
var MeetingInfoV2CaptchaError = /*#__PURE__*/function (_Error3) {
  (0, _inherits2.default)(MeetingInfoV2CaptchaError, _Error3);
  var _super3 = _createSuper(MeetingInfoV2CaptchaError);
  /**
   *
   * @constructor
   * @param {Number} [wbxAppApiErrorCode]
   * @param {Object} [captchaInfo]
   * @param {String} [message]
   */
  function MeetingInfoV2CaptchaError(wbxAppApiErrorCode, captchaInfo) {
    var _this3;
    var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CAPTCHA_ERROR_DEFAULT_MESSAGE;
    (0, _classCallCheck2.default)(this, MeetingInfoV2CaptchaError);
    _this3 = _super3.call(this, "".concat(message, ", code=").concat(wbxAppApiErrorCode));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "captchaInfo", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "isPasswordRequired", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "sdkMessage", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "wbxAppApiCode", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "body", void 0);
    _this3.name = 'MeetingInfoV2PasswordError';
    _this3.sdkMessage = message;
    _this3.stack = new Error().stack;
    _this3.wbxAppApiCode = wbxAppApiErrorCode;
    _this3.isPasswordRequired = CAPTCHA_ERROR_REQUIRES_PASSWORD_CODES.includes(wbxAppApiErrorCode);
    _this3.captchaInfo = captchaInfo;
    return _this3;
  }
  return (0, _createClass2.default)(MeetingInfoV2CaptchaError);
}( /*#__PURE__*/(0, _wrapNativeSuper2.default)(Error));
/**
 * @class MeetingInfo
 */
exports.MeetingInfoV2CaptchaError = MeetingInfoV2CaptchaError;
var MeetingInfoV2 = /*#__PURE__*/function () {
  /**
   *
   * @param {WebexSDK} webex
   */
  function MeetingInfoV2(webex) {
    (0, _classCallCheck2.default)(this, MeetingInfoV2);
    (0, _defineProperty2.default)(this, "webex", void 0);
    this.webex = webex;
  }

  /**
   * converts hydra id into conversation url and persons Id
   * @param {String} destination one of many different types of destinations to look up info for
   * @param {String} [type] to match up with the destination value
   * @returns {Promise} destination and type
   * @public
   * @memberof MeetingInfo
   */
  (0, _createClass2.default)(MeetingInfoV2, [{
    key: "fetchInfoOptions",
    value: function fetchInfoOptions(destination) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return _utilv.default.getDestinationType({
        destination: destination,
        type: type,
        webex: this.webex
      });
    }

    /**
     * Creates adhoc space meetings for a space by fetching the conversation infomation
     * @param {String} conversationUrl conversationUrl to start adhoc meeting on
     * @returns {Promise} returns a meeting info object
     * @public
     * @memberof MeetingInfo
     */
  }, {
    key: "createAdhocSpaceMeeting",
    value: function () {
      var _createAdhocSpaceMeeting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(conversationUrl) {
        var _this4 = this;
        var getInvitees;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.webex.meetings.preferredWebexSite) {
                _context.next = 2;
                break;
              }
              throw Error('No preferred webex site found');
            case 2:
              getInvitees = function getInvitees() {
                var particpants = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var invitees = [];
                if (particpants) {
                  particpants.forEach(function (participant) {
                    invitees.push({
                      email: participant.emailAddress,
                      ciUserUuid: participant.entryUUID
                    });
                  });
                }
                return invitees;
              };
              return _context.abrupt("return", this.webex.request({
                uri: conversationUrl,
                qs: {
                  includeParticipants: true
                },
                disableTransform: true
              }).then(function (_ref) {
                var _conversation$partici;
                var conversation = _ref.body;
                var body = {
                  title: conversation.displayName,
                  spaceUrl: conversation.url,
                  keyUrl: conversation.encryptionKeyUrl,
                  kroUrl: conversation.kmsResourceObjectUrl,
                  invitees: getInvitees((_conversation$partici = conversation.participants) === null || _conversation$partici === void 0 ? void 0 : _conversation$partici.items)
                };
                var uri = _this4.webex.meetings.preferredWebexSite ? "https://".concat(_this4.webex.meetings.preferredWebexSite, "/wbxappapi/v2/meetings/spaceInstant") : '';
                _metrics.default.sendBehavioralMetric(_constants2.default.ADHOC_MEETING_SUCCESS);
                return _this4.webex.request({
                  method: _constants.HTTP_VERBS.POST,
                  uri: uri,
                  body: body
                });
              }).catch(function (err) {
                var _err$body, _err$body2;
                _metrics.default.sendBehavioralMetric(_constants2.default.ADHOC_MEETING_FAILURE, {
                  reason: err.message,
                  stack: err.stack
                });
                throw new MeetingInfoV2AdhocMeetingError((_err$body = err.body) === null || _err$body === void 0 ? void 0 : _err$body.code, (_err$body2 = err.body) === null || _err$body2 === void 0 ? void 0 : _err$body2.message);
              }));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function createAdhocSpaceMeeting(_x) {
        return _createAdhocSpaceMeeting.apply(this, arguments);
      }
      return createAdhocSpaceMeeting;
    }()
    /**
     * Fetches meeting info from the server
     * @param {String} destination one of many different types of destinations to look up info for
     * @param {String} [type] to match up with the destination value
     * @param {String} password
     * @param {Object} captchaInfo
     * @param {String} captchaInfo.code
     * @param {String} captchaInfo.id
     * @returns {Promise} returns a meeting info object
     * @public
     * @memberof MeetingInfo
     */
  }, {
    key: "fetchMeetingInfo",
    value: function () {
      var _fetchMeetingInfo = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(destination) {
        var type,
          password,
          captchaInfo,
          destinationType,
          body,
          options,
          directURI,
          _args2 = arguments;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              type = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
              password = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : null;
              captchaInfo = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : null;
              _context2.next = 5;
              return _utilv.default.getDestinationType({
                destination: destination,
                type: type,
                webex: this.webex
              });
            case 5:
              destinationType = _context2.sent;
              if (!(destinationType.type === _constants._CONVERSATION_URL_ && this.webex.config.meetings.experimental.enableAdhocMeetings && this.webex.meetings.preferredWebexSite)) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return", this.createAdhocSpaceMeeting(destinationType.destination));
            case 8:
              _context2.next = 10;
              return _utilv.default.getRequestBody(_objectSpread(_objectSpread({}, destinationType), {}, {
                password: password,
                captchaInfo: captchaInfo
              }));
            case 10:
              body = _context2.sent;
              options = {
                method: _constants.HTTP_VERBS.POST,
                body: body
              };
              _context2.next = 14;
              return _utilv.default.getDirectMeetingInfoURI(destinationType);
            case 14:
              directURI = _context2.sent;
              if (directURI) {
                options.uri = directURI;
              } else {
                options.service = _constants.WBXAPPAPI_SERVICE;
                options.resource = 'meetingInfo';
              }
              return _context2.abrupt("return", this.webex.request(options).then(function (response) {
                _metrics.default.sendBehavioralMetric(_constants2.default.FETCH_MEETING_INFO_V1_SUCCESS);
                return response;
              }).catch(function (err) {
                if ((err === null || err === void 0 ? void 0 : err.statusCode) === 403) {
                  var _err$body3, _err$body4, _err$body4$data;
                  _metrics.default.sendBehavioralMetric(_constants2.default.VERIFY_PASSWORD_ERROR, {
                    reason: err.message,
                    stack: err.stack
                  });
                  throw new MeetingInfoV2PasswordError((_err$body3 = err.body) === null || _err$body3 === void 0 ? void 0 : _err$body3.code, (_err$body4 = err.body) === null || _err$body4 === void 0 ? void 0 : (_err$body4$data = _err$body4.data) === null || _err$body4$data === void 0 ? void 0 : _err$body4$data.meetingInfo);
                }
                if ((err === null || err === void 0 ? void 0 : err.statusCode) === 423) {
                  var _err$body5;
                  _metrics.default.sendBehavioralMetric(_constants2.default.VERIFY_CAPTCHA_ERROR, {
                    reason: err.message,
                    stack: err.stack
                  });
                  throw new MeetingInfoV2CaptchaError((_err$body5 = err.body) === null || _err$body5 === void 0 ? void 0 : _err$body5.code, {
                    captchaId: err.body.captchaID,
                    verificationImageURL: err.body.verificationImageURL,
                    verificationAudioURL: err.body.verificationAudioURL,
                    refreshURL: err.body.refreshURL
                  });
                }
                _metrics.default.sendBehavioralMetric(_constants2.default.FETCH_MEETING_INFO_V1_FAILURE, {
                  reason: err.message,
                  stack: err.stack
                });
                throw err;
              }));
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchMeetingInfo(_x2) {
        return _fetchMeetingInfo.apply(this, arguments);
      }
      return fetchMeetingInfo;
    }()
  }]);
  return MeetingInfoV2;
}();
exports.default = MeetingInfoV2;
//# sourceMappingURL=meeting-info-v2.js.map
